module.exports = __webpack_public_path__ + "img/01-06-2026.0820cec5.jpg";